import { FormEvent, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { rooms } from "./roomData";
import "./RoomService.css";
import "./RoomServiceRed.css";

const RoomDetails = () => {
  const { roomId } = useParams();
  const room = rooms.find((item) => item.id === roomId) || rooms[0];
  const [activeImage, setActiveImage] = useState(0);
  const [booked, setBooked] = useState(false);

  const submitBooking = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBooked(true);
  };

  return (
    <main className="room-page details-page">
      <div className="details-topbar"><Link to="/room-service">← All rooms</Link><span>Room service booking</span></div>
      <section className="room-detail-heading">
        <div><p className="eyebrow">{room.type}</p><h1>{room.name}</h1><p>Up to {room.guests} guests <span>•</span> {room.size}</p></div>
        <p className="detail-price"><strong>₦{room.price.toLocaleString()}</strong> / night</p>
      </section>

      <section className="media-grid" aria-label={`${room.name} gallery`}>
        <img className="main-gallery-image" src={room.images[activeImage] || room.image} alt={`${room.name} view ${activeImage + 1}`} />
        <div className="gallery-thumbnails">
          {(room.images.length ? room.images : [room.image]).map((image, index) => <button type="button" key={image} onClick={() => setActiveImage(index)} className={activeImage === index ? "active" : ""}><img src={image} alt={`View ${index + 1}`} /></button>)}
        </div>
        <div className="room-video">
          <iframe src="https://www.youtube-nocookie.com/embed/Scxs7L0vhZ4?rel=0" title="A short room tour" allowFullScreen />
          <p><span>01</span> Watch a short room tour</p>
        </div>
      </section>

      <section className="booking-layout">
        <div className="room-description">
          <p className="eyebrow">About this room</p>
          <h2>Comfort, designed around you.</h2>
          <p>{room.description}</p>
          <div className="amenities">{room.amenities.map((amenity) => <span key={amenity}>✓ {amenity}</span>)}</div>
          <div className="how-to-book"><span>02</span><div><h3>How to book</h3><p>Select your stay dates and guest count, then send your request. We’ll confirm your booking by email.</p></div></div>
        </div>
        <form className="booking-form" onSubmit={submitBooking}>
          <div className="form-heading"><div><p className="eyebrow">Reserve your stay</p><h2>Choose your dates</h2></div><span className="secure-note">⌁ Secure request</span></div>
          <label>Check in<input type="date" required /></label>
          <label>Check out<input type="date" required /></label>
          <label>Guests<select defaultValue="2"><option value="1">1 guest</option><option value="2">2 guests</option><option value="3">3 guests</option><option value="4">4 guests</option></select></label>
          <label>Your email<input type="email" placeholder="you@example.com" required /></label>
          <button type="submit">Request booking <span>→</span></button>
          {booked && <div className="booking-success" role="alert"><strong>Booking request sent!</strong><span>Thank you — we’ve received your request for the {room.name}. Our team will confirm your stay by email shortly.</span></div>}
        </form>
      </section>
    </main>
  );
};

export default RoomDetails;
